import { apiClient } from '../apiClient';
import { handleRequest } from '../apiWrapper';
import type { QuoteHistoryPeriod, QuoteHistoryResponse } from '@/shared/types';

type GetQuoteHistoryParams = {
  asset: string;
  baseAsset: string;
  period: QuoteHistoryPeriod;
};

export const getQuoteHistory = async ({
  asset,
  baseAsset,
  period,
}: GetQuoteHistoryParams): Promise<QuoteHistoryResponse> => {
  const request = () =>
    apiClient.get(`/assets/${asset}/quotehistory`, {
      params: { baseasset: baseAsset, period },
    });
  const response = await handleRequest<QuoteHistoryResponse>(request);
  return response.data;
};
